import { useQuery } from "@tanstack/react-query";
import { getMerchantsStats } from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const MERCHANT_STATS_QUERY_KEY = "MERCHANT_STATS";

export const merchantStatsKeys = {
  all: [MERCHANT_STATS_QUERY_KEY],
  byOwnOnly: (ownOnly: boolean) => [...merchantStatsKeys.all, { ownOnly }],
};

export const useMerchantStatsQuery = (ownOnly = false) =>
  useQuery({
    queryKey: merchantStatsKeys.byOwnOnly(ownOnly),
    queryFn: processResponseWithApiProblemDetails(() =>
      getMerchantsStats(ownOnly),
    ),
    staleTime: 2 * MS_TIME.minute,
  });
